import { TableWrapper, TableHead, TableBody } from "./components";
import { TableRow } from "./components/TableRow/TableRow";
import style from "./TableHistory.module.scss";
import { useState } from "react";

export function TableHistory() {
    const [rangeDate, setRangeDate] = useState<{ start: string, end: string }>({ start: "Початкова дата", end: "Кінцева дата" })

    return (
        <div className={style.tableManager}>
            <div className={style.tableContainer}>
                <div data-scrollable className={style.scrollBox}>
                    <TableWrapper>
                        <TableHead />
                        <TableBody>
                            {(data) => (
                                <TableRow key={data.id} data={data} />
                            )}
                        </TableBody>
                    </TableWrapper>
                </div>
            </div>
        </div>
    )
}